import styled from 'styled-components'
// import { rem } from 'polished'
import { Box } from 'rebass'
// import media from '../../../utils/style'

const InlineInfoWrapper = styled(Box)`
  padding-bottom: 16px;
`

const InlineInfo = styled(Box)`
  line-height: 1.1;
  vertical-align: middle;
  margin-bottom: 8px;
  color: ${(props) => props.theme.colors.grey_slate};

  a {
    text-decoration: none;
  }
`

const InlineInfoDetails = styled.span`
  display: inline-block;
  vertical-align: middle;

  a {
    color: ${(props) => props.theme.colors.grey_slate};
  }
`

export { InlineInfoWrapper, InlineInfo, InlineInfoDetails }
